import { useState, useMemo } from 'react';

const rawTemplate = `
<!DOCTYPE html>
<html lang="en">

<head>
  <meta charset="UTF-8">
  <meta name="viewport" content="width=device-width, initial-scale=1.0">
  <meta http-equiv="X-UA-Compatible" content="IE=edge">
  <title>SaleDesk POS — Daily Business Update</title>
  <!--[if mso]>
<noscript><xml><o:OfficeDocumentSettings><o:PixelsPerInch>96</o:PixelsPerInch></o:OfficeDocumentSettings></xml></noscript>
<![endif]-->
</head>

<body
  style="margin:0;padding:0;background-color:#F0F4F8;font-family:Arial,Helvetica,sans-serif;-webkit-text-size-adjust:100%;-ms-text-size-adjust:100%;">

  <!-- Email preview text (hidden) -->
  <div style="display:none;max-height:0;overflow:hidden;mso-hide:all;">
    Your daily business update from SaleDesk POS — Sales, Stock & Payment Summary for {{report_date}}
    &nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;
  </div>

  <!-- Outer wrapper -->
  <table width="100%" cellpadding="0" cellspacing="0" border="0" style="background-color:#F0F4F8;">
    <tr>
      <td align="center" style="padding:24px 12px;">

        <!-- Main container -->
        <table width="620" cellpadding="0" cellspacing="0" border="0" style="max-width:620px;width:100%;">

          <!-- SECTION 1 — HEADER -->
          <tr>
            <td>
              <table width="100%" cellpadding="0" cellspacing="0" border="0"
                style="background:linear-gradient(135deg,#0F2D5E 0%,#1A4A8C 100%);border-radius:12px 12px 0 0;">
                <tr>
                  <td style="padding:32px 36px 24px;">
                    <!-- Logo row -->
                    <table width="100%" cellpadding="0" cellspacing="0" border="0">
                      <tr>
                        <td>
                          <!-- Logo lockup -->
                          <table cellpadding="0" cellspacing="0" border="0">
                            <tr>
                              <td
                                style="background-color:#2563EB;border-radius:8px;padding:8px 12px;vertical-align:middle;">
                                <span
                                  style="font-family:Arial,sans-serif;font-size:18px;font-weight:700;color:#FFFFFF;letter-spacing:-0.5px;">SD</span>
                              </td>
                              <td style="padding-left:10px;vertical-align:middle;">
                                <div
                                  style="font-family:Arial,sans-serif;font-size:17px;font-weight:700;color:#FFFFFF;line-height:1.2;">
                                  SaleDesk POS</div>
                                <div
                                  style="font-family:Arial,sans-serif;font-size:11px;color:#93C5FD;letter-spacing:0.5px;margin-top:2px;">
                                  BUSINESS MANAGEMENT SYSTEM</div>
                              </td>
                            </tr>
                          </table>
                        </td>
                        <td align="right" valign="top">
                          <div
                            style="background-color:rgba(255,255,255,0.12);border-radius:6px;padding:6px 14px;display:inline-block;">
                            <div
                              style="font-family:Arial,sans-serif;font-size:11px;color:#BFDBFE;text-transform:uppercase;letter-spacing:0.5px;">
                              Report Date</div>
                            <div
                              style="font-family:Arial,sans-serif;font-size:14px;font-weight:700;color:#FFFFFF;margin-top:2px;">
                              {{report_date}}</div>
                          </div>
                        </td>
                      </tr>
                    </table>

                    <!-- Divider -->
                    <div style="border-top:1px solid rgba(255,255,255,0.15);margin:20px 0;"></div>

                    <!-- Greeting -->
                    <div
                      style="font-family:Arial,sans-serif;font-size:22px;font-weight:700;color:#FFFFFF;line-height:1.3;">
                      Assalamu Alaikum, {{owner_name}} 👋
                    </div>
                    <div
                      style="font-family:Arial,sans-serif;font-size:14px;color:#BFDBFE;margin-top:8px;line-height:1.6;">
                      Here is your daily business summary for <strong
                        style="color:#FFFFFF;">{{company_name}}</strong>.<br>
                      Period: <strong style="color:#FFFFFF;">{{report_period}}</strong>
                    </div>
                  </td>
                </tr>
              </table>
            </td>
          </tr>

          <!-- SUBSCRIPTION ALERT BANNER (conditional) -->
          <tr>
            <td>
              <table width="100%" cellpadding="0" cellspacing="0" border="0"
                style="background-color:#FEF3C7;border-left:4px solid #F59E0B;">
                <tr>
                  <td style="padding:12px 20px;">
                    <table width="100%" cellpadding="0" cellspacing="0" border="0">
                      <tr>
                        <td style="vertical-align:middle;">
                          <span style="font-size:16px;">⚠️</span>
                          <span
                            style="font-family:Arial,sans-serif;font-size:13px;font-weight:700;color:#92400E;margin-left:6px;">Subscription
                            Expiring Soon</span>
                          <span style="font-family:Arial,sans-serif;font-size:13px;color:#92400E;margin-left:4px;">—
                            Your subscription expires in <strong>{{days_remaining}} days</strong>
                            ({{subscription_end_date}}). Please renew to avoid service interruption.</span>
                        </td>
                        <td align="right" valign="middle" style="padding-left:12px;white-space:nowrap;">
                          <a href="{{subscription_url}}"
                            style="font-family:Arial,sans-serif;font-size:12px;font-weight:700;color:#92400E;text-decoration:underline;">Renew
                            Now →</a>
                        </td>
                      </tr>
                    </table>
                  </td>
                </tr>
              </table>
            </td>
          </tr>

          <!-- SECTION 2 — BUSINESS HEALTH CARDS -->
          <tr>
            <td style="background-color:#FFFFFF;padding:28px 28px 0;">
              <div
                style="font-family:Arial,sans-serif;font-size:13px;font-weight:700;color:#6B7280;text-transform:uppercase;letter-spacing:0.8px;margin-bottom:16px;">
                📊 Daily Shop Summary</div>

              <!-- Cards row 1 -->
              <table width="100%" cellpadding="0" cellspacing="0" border="0">
                <tr>
                  <!-- Total Sales -->
                  <td width="32%"
                    style="background:linear-gradient(135deg,#EFF6FF,#DBEAFE);border-radius:10px;padding:16px;vertical-align:top;">
                    <div
                      style="font-family:Arial,sans-serif;font-size:11px;color:#1D4ED8;font-weight:700;text-transform:uppercase;letter-spacing:0.5px;">
                      Total Sales</div>
                    <div style="font-family:Arial,sans-serif;font-size:11px;color:#6B7280;margin-top:2px;">Kul Bikri
                    </div>
                    <div
                      style="font-family:Arial,sans-serif;font-size:22px;font-weight:700;color:#1E3A8A;margin-top:8px;line-height:1;">
                      Rs. {{total_sales}}</div>
                  </td>
                  <td width="2%"></td>
                  <!-- Total Invoices -->
                  <td width="32%"
                    style="background:linear-gradient(135deg,#F0FDF4,#DCFCE7);border-radius:10px;padding:16px;vertical-align:top;">
                    <div
                      style="font-family:Arial,sans-serif;font-size:11px;color:#16A34A;font-weight:700;text-transform:uppercase;letter-spacing:0.5px;">
                      Total Invoices</div>
                    <div style="font-family:Arial,sans-serif;font-size:11px;color:#6B7280;margin-top:2px;">Kul Bills
                    </div>
                    <div
                      style="font-family:Arial,sans-serif;font-size:22px;font-weight:700;color:#14532D;margin-top:8px;line-height:1;">
                      {{total_invoices}}</div>
                  </td>
                  <td width="2%"></td>
                  <!-- Payments Received -->
                  <td width="32%"
                    style="background:linear-gradient(135deg,#F0FDF4,#DCFCE7);border-radius:10px;padding:16px;vertical-align:top;">
                    <div
                      style="font-family:Arial,sans-serif;font-size:11px;color:#16A34A;font-weight:700;text-transform:uppercase;letter-spacing:0.5px;">
                      Payments Received</div>
                    <div style="font-family:Arial,sans-serif;font-size:11px;color:#6B7280;margin-top:2px;">Wasool</div>
                    <div
                      style="font-family:Arial,sans-serif;font-size:22px;font-weight:700;color:#14532D;margin-top:8px;line-height:1;">
                      Rs. {{payments_received}}</div>
                  </td>
                </tr>
              </table>

              <!-- Cards row 2 -->
              <table width="100%" cellpadding="0" cellspacing="0" border="0" style="margin-top:10px;">
                <tr>
                  <!-- Cash Collection -->
                  <td width="32%"
                    style="background-color:#F9FAFB;border:1px solid #E5E7EB;border-radius:10px;padding:16px;vertical-align:top;">
                    <div
                      style="font-family:Arial,sans-serif;font-size:11px;color:#374151;font-weight:700;text-transform:uppercase;letter-spacing:0.5px;">
                      Cash Collection</div>
                    <div
                      style="font-family:Arial,sans-serif;font-size:20px;font-weight:700;color:#111827;margin-top:8px;line-height:1;">
                      Rs. {{cash_collection}}</div>
                  </td>
                  <td width="2%"></td>
                  <!-- Bank Collection -->
                  <td width="32%"
                    style="background-color:#F9FAFB;border:1px solid #E5E7EB;border-radius:10px;padding:16px;vertical-align:top;">
                    <div
                      style="font-family:Arial,sans-serif;font-size:11px;color:#374151;font-weight:700;text-transform:uppercase;letter-spacing:0.5px;">
                      Bank / Online</div>
                    <div style="font-family:Arial,sans-serif;font-size:11px;color:#6B7280;margin-top:2px;">Bank Transfer
                    </div>
                    <div
                      style="font-family:Arial,sans-serif;font-size:20px;font-weight:700;color:#111827;margin-top:8px;line-height:1;">
                      Rs. {{bank_collection}}</div>
                  </td>
                  <td width="2%"></td>
                  <!-- Credit -->
                  <td width="32%"
                    style="background:linear-gradient(135deg,#FFF7ED,#FFEDD5);border:1px solid #FED7AA;border-radius:10px;padding:16px;vertical-align:top;">
                    <div
                      style="font-family:Arial,sans-serif;font-size:11px;color:#C2410C;font-weight:700;text-transform:uppercase;letter-spacing:0.5px;">
                      Credit / Pending</div>
                    <div style="font-family:Arial,sans-serif;font-size:11px;color:#6B7280;margin-top:2px;">Baqi Rakam
                    </div>
                    <div
                      style="font-family:Arial,sans-serif;font-size:20px;font-weight:700;color:#7C2D12;margin-top:8px;line-height:1;">
                      Rs. {{credit_amount}}</div>
                  </td>
                </tr>
              </table>
            </td>
          </tr>

          <!-- SECTION 3 — DAILY SALES SUMMARY -->
          <tr>
            <td style="background-color:#FFFFFF;padding:24px 28px 0;">
              <div style="border-top:1px solid #F3F4F6;padding-top:24px;">
                <div
                  style="font-family:Arial,sans-serif;font-size:13px;font-weight:700;color:#6B7280;text-transform:uppercase;letter-spacing:0.8px;margin-bottom:14px;">
                  🧾 Daily Sales Summary — Roz Ki Bikri</div>

                <table width="100%" cellpadding="0" cellspacing="0" border="0"
                  style="border-radius:8px;overflow:hidden;border:1px solid #E5E7EB;">
                  <tr style="background-color:#F8FAFF;">
                    <td
                      style="font-family:Arial,sans-serif;font-size:12px;font-weight:700;color:#374151;padding:10px 16px;border-bottom:1px solid #E5E7EB;">
                      Metric</td>
                    <td align="right"
                      style="font-family:Arial,sans-serif;font-size:12px;font-weight:700;color:#374151;padding:10px 16px;border-bottom:1px solid #E5E7EB;">
                      Value</td>
                  </tr>
                  <tr style="background-color:#FFFFFF;">
                    <td
                      style="font-family:Arial,sans-serif;font-size:13px;color:#374151;padding:10px 16px;border-bottom:1px solid #F3F4F6;">
                      Gross Sales (Total)</td>
                    <td align="right"
                      style="font-family:Arial,sans-serif;font-size:13px;font-weight:600;color:#111827;padding:10px 16px;border-bottom:1px solid #F3F4F6;">
                      Rs. {{gross_sales}}</td>
                  </tr>
                  <tr style="background-color:#FAFAFA;">
                    <td
                      style="font-family:Arial,sans-serif;font-size:13px;color:#374151;padding:10px 16px;border-bottom:1px solid #F3F4F6;">
                      Discounts Given <span style="color:#9CA3AF;font-size:11px;">(Chhoot Di Gayi)</span></td>
                    <td align="right"
                      style="font-family:Arial,sans-serif;font-size:13px;font-weight:600;color:#DC2626;padding:10px 16px;border-bottom:1px solid #F3F4F6;">
                      - Rs. {{discount_total}}</td>
                  </tr>
                  <tr style="background-color:#FFFFFF;">
                    <td
                      style="font-family:Arial,sans-serif;font-size:13px;color:#374151;padding:10px 16px;border-bottom:1px solid #F3F4F6;">
                      Tax Collected</td>
                    <td align="right"
                      style="font-family:Arial,sans-serif;font-size:13px;font-weight:600;color:#111827;padding:10px 16px;border-bottom:1px solid #F3F4F6;">
                      Rs. {{tax_total}}</td>
                  </tr>
                  <tr style="background-color:#EFF6FF;">
                    <td
                      style="font-family:Arial,sans-serif;font-size:13px;font-weight:700;color:#1E40AF;padding:10px 16px;border-bottom:1px solid #DBEAFE;">
                      Net Sales (Asli Kamai)</td>
                    <td align="right"
                      style="font-family:Arial,sans-serif;font-size:14px;font-weight:700;color:#1E40AF;padding:10px 16px;border-bottom:1px solid #DBEAFE;">
                      Rs. {{net_sales}}</td>
                  </tr>
                  <tr style="background-color:#FFFFFF;">
                    <td
                      style="font-family:Arial,sans-serif;font-size:13px;color:#374151;padding:10px 16px;border-bottom:1px solid #F3F4F6;">
                      Product Sales</td>
                    <td align="right"
                      style="font-family:Arial,sans-serif;font-size:13px;font-weight:600;color:#111827;padding:10px 16px;border-bottom:1px solid #F3F4F6;">
                      Rs. {{product_sales}}</td>
                  </tr>
                  <tr style="background-color:#FAFAFA;">
                    <td
                      style="font-family:Arial,sans-serif;font-size:13px;color:#374151;padding:10px 16px;border-bottom:1px solid #F3F4F6;">
                      Service Sales</td>
                    <td align="right"
                      style="font-family:Arial,sans-serif;font-size:13px;font-weight:600;color:#111827;padding:10px 16px;border-bottom:1px solid #F3F4F6;">
                      Rs. {{service_sales}}</td>
                  </tr>
                  <tr style="background-color:#FFFFFF;">
                    <td
                      style="font-family:Arial,sans-serif;font-size:13px;color:#374151;padding:10px 16px;border-bottom:1px solid #F3F4F6;">
                      Average Invoice Value</td>
                    <td align="right"
                      style="font-family:Arial,sans-serif;font-size:13px;font-weight:600;color:#111827;padding:10px 16px;border-bottom:1px solid #F3F4F6;">
                      Rs. {{average_invoice_value}}</td>
                  </tr>
                  <tr style="background-color:#FAFAFA;">
                    <td style="font-family:Arial,sans-serif;font-size:13px;color:#374151;padding:10px 16px;">Highest
                      Single Invoice</td>
                    <td align="right"
                      style="font-family:Arial,sans-serif;font-size:13px;font-weight:600;color:#059669;padding:10px 16px;">
                      Rs. {{highest_invoice_value}}</td>
                  </tr>
                </table>
              </div>
            </td>
          </tr>

          <!-- SECTION 4 — PAYMENT COLLECTION -->
          <tr>
            <td style="background-color:#FFFFFF;padding:24px 28px 0;">
              <div style="border-top:1px solid #F3F4F6;padding-top:24px;">
                <div
                  style="font-family:Arial,sans-serif;font-size:13px;font-weight:700;color:#6B7280;text-transform:uppercase;letter-spacing:0.8px;margin-bottom:14px;">
                  💳 Payment Collection — Raseedon Ki Tafseel</div>

                <table width="100%" cellpadding="0" cellspacing="0" border="0"
                  style="border-radius:8px;overflow:hidden;border:1px solid #E5E7EB;">
                  <tr style="background-color:#F8FAFF;">
                    <td
                      style="font-family:Arial,sans-serif;font-size:12px;font-weight:700;color:#374151;padding:10px 16px;border-bottom:1px solid #E5E7EB;">
                      Payment Mode</td>
                    <td align="right"
                      style="font-family:Arial,sans-serif;font-size:12px;font-weight:700;color:#374151;padding:10px 16px;border-bottom:1px solid #E5E7EB;">
                      Amount</td>
                    <td align="right"
                      style="font-family:Arial,sans-serif;font-size:12px;font-weight:700;color:#374151;padding:10px 16px;border-bottom:1px solid #E5E7EB;">
                      %</td>
                  </tr>
                  <tr>
                    <td
                      style="font-family:Arial,sans-serif;font-size:13px;color:#374151;padding:10px 16px;border-bottom:1px solid #F3F4F6;">
                      💵 Cash (Naqdah)</td>
                    <td align="right"
                      style="font-family:Arial,sans-serif;font-size:13px;font-weight:600;color:#111827;padding:10px 16px;border-bottom:1px solid #F3F4F6;">
                      Rs. {{cash_amount}}</td>
                    <td align="right"
                      style="font-family:Arial,sans-serif;font-size:12px;color:#6B7280;padding:10px 16px;border-bottom:1px solid #F3F4F6;">
                      {{cash_pct}}%</td>
                  </tr>
                  
                  {{bank_accounts_html}}

                  <tr style="background-color:#FFF7ED;">
                    <td
                      style="font-family:Arial,sans-serif;font-size:13px;font-weight:600;color:#C2410C;padding:10px 16px;">
                      ⏳ Credit / Pay Later (Udhaar)</td>
                    <td align="right"
                      style="font-family:Arial,sans-serif;font-size:13px;font-weight:700;color:#C2410C;padding:10px 16px;">
                      Rs. {{credit_amount}}</td>
                    <td align="right"
                      style="font-family:Arial,sans-serif;font-size:12px;color:#C2410C;padding:10px 16px;">
                      {{credit_pct}}%</td>
                  </tr>
                </table>
              </div>
            </td>
          </tr>

          <!-- SECTION 5 — LOW STOCK ALERTS -->
          <tr>
            <td style="background-color:#FFFFFF;padding:24px 28px 0;">
              <div style="border-top:1px solid #F3F4F6;padding-top:24px;">
                <div
                  style="font-family:Arial,sans-serif;font-size:13px;font-weight:700;color:#6B7280;text-transform:uppercase;letter-spacing:0.8px;margin-bottom:14px;">
                  🔴 Low Stock Alerts — Kum Maal</div>

                <!-- CONDITION: Low stock items found -->
                <table width="100%" cellpadding="0" cellspacing="0" border="0"
                  style="border-radius:8px;overflow:hidden;border:1px solid #FCA5A5;">
                  <tr style="background-color:#FEF2F2;">
                    <td
                      style="font-family:Arial,sans-serif;font-size:12px;font-weight:700;color:#991B1B;padding:10px 14px;border-bottom:1px solid #FCA5A5;">
                      Product Name</td>
                    <td align="center"
                      style="font-family:Arial,sans-serif;font-size:12px;font-weight:700;color:#991B1B;padding:10px 14px;border-bottom:1px solid #FCA5A5;">
                      Current</td>
                    <td align="center"
                      style="font-family:Arial,sans-serif;font-size:12px;font-weight:700;color:#991B1B;padding:10px 14px;border-bottom:1px solid #FCA5A5;">
                      Minimum</td>
                    <td
                      style="font-family:Arial,sans-serif;font-size:12px;font-weight:700;color:#991B1B;padding:10px 14px;border-bottom:1px solid #FCA5A5;">
                      Action</td>
                  </tr>
                  <tr>
                    <td style="padding:10px 14px;border-bottom:1px solid #FEE2E2;">
                      <div style="font-family:Arial,sans-serif;font-size:13px;font-weight:600;color:#111827;">4MP IP
                        Camera</div>
                      <div style="font-family:Arial,sans-serif;font-size:11px;color:#9CA3AF;margin-top:2px;">CCTV /
                        Cameras</div>
                    </td>
                    <td align="center" style="padding:10px 14px;border-bottom:1px solid #FEE2E2;">
                      <span
                        style="display:inline-block;background-color:#FEE2E2;color:#DC2626;font-family:Arial,sans-serif;font-size:12px;font-weight:700;padding:3px 10px;border-radius:20px;">3
                        pcs</span>
                    </td>
                    <td align="center"
                      style="font-family:Arial,sans-serif;font-size:13px;color:#6B7280;padding:10px 14px;border-bottom:1px solid #FEE2E2;">
                      10 pcs</td>
                    <td style="padding:10px 14px;border-bottom:1px solid #FEE2E2;"><span
                        style="font-family:Arial,sans-serif;font-size:12px;color:#DC2626;font-weight:600;">⚡ Reorder
                        Soon</span></td>
                  </tr>
                </table>
              </div>
            </td>
          </tr>

          <!-- SECTION 6 — TOP SELLING PRODUCTS -->
          <tr>
            <td style="background-color:#FFFFFF;padding:24px 28px 0;">
              <div style="border-top:1px solid #F3F4F6;padding-top:24px;">
                <div
                  style="font-family:Arial,sans-serif;font-size:13px;font-weight:700;color:#6B7280;text-transform:uppercase;letter-spacing:0.8px;margin-bottom:14px;">
                  🏆 Top Selling Items Today — Sab Se Zyada Bikne Wale</div>

                <table width="100%" cellpadding="0" cellspacing="0" border="0"
                  style="border-radius:8px;overflow:hidden;border:1px solid #E5E7EB;">
                  <tr style="background-color:#F8FAFF;">
                    <td
                      style="font-family:Arial,sans-serif;font-size:12px;font-weight:700;color:#374151;padding:10px 16px;border-bottom:1px solid #E5E7EB;">
                      #</td>
                    <td
                      style="font-family:Arial,sans-serif;font-size:12px;font-weight:700;color:#374151;padding:10px 16px;border-bottom:1px solid #E5E7EB;">
                      Item</td>
                    <td align="center"
                      style="font-family:Arial,sans-serif;font-size:12px;font-weight:700;color:#374151;padding:10px 16px;border-bottom:1px solid #E5E7EB;">
                      Type</td>
                    <td align="center"
                      style="font-family:Arial,sans-serif;font-size:12px;font-weight:700;color:#374151;padding:10px 16px;border-bottom:1px solid #E5E7EB;">
                      Qty</td>
                    <td align="right"
                      style="font-family:Arial,sans-serif;font-size:12px;font-weight:700;color:#374151;padding:10px 16px;border-bottom:1px solid #E5E7EB;">
                      Amount</td>
                  </tr>
                  <tr>
                    <td
                      style="font-family:Arial,sans-serif;font-size:13px;font-weight:700;color:#D97706;padding:10px 16px;border-bottom:1px solid #F3F4F6;">
                      🥇</td>
                    <td
                      style="font-family:Arial,sans-serif;font-size:13px;color:#111827;padding:10px 16px;border-bottom:1px solid #F3F4F6;">
                      4MP IP Camera (Dahua)</td>
                    <td align="center" style="padding:10px 16px;border-bottom:1px solid #F3F4F6;"><span
                        style="background-color:#EFF6FF;color:#1D4ED8;font-family:Arial,sans-serif;font-size:11px;font-weight:600;padding:3px 8px;border-radius:4px;">Product</span>
                    </td>
                    <td align="center"
                      style="font-family:Arial,sans-serif;font-size:13px;font-weight:600;color:#374151;padding:10px 16px;border-bottom:1px solid #F3F4F6;">
                      8</td>
                    <td align="right"
                      style="font-family:Arial,sans-serif;font-size:13px;font-weight:600;color:#059669;padding:10px 16px;border-bottom:1px solid #F3F4F6;">
                      Rs. 120,000</td>
                  </tr>
                </table>
              </div>
            </td>
          </tr>

          <!-- SECTION 7 — SERVICE WORK SUMMARY -->
          <tr>
            <td style="background-color:#FFFFFF;padding:24px 28px 0;">
              <div style="border-top:1px solid #F3F4F6;padding-top:24px;">
                <div
                  style="font-family:Arial,sans-serif;font-size:13px;font-weight:700;color:#6B7280;text-transform:uppercase;letter-spacing:0.8px;margin-bottom:14px;">
                  🔧 Service Work Summary — Kaam Ki Report</div>

                <!-- 2-col service cards -->
                <table width="100%" cellpadding="0" cellspacing="0" border="0">
                  <tr>
                    <td width="48%"
                      style="background-color:#F0FDF4;border:1px solid #86EFAC;border-radius:8px;padding:14px 16px;text-align:center;vertical-align:top;">
                      <div style="font-family:Arial,sans-serif;font-size:28px;font-weight:700;color:#16A34A;">
                        {{completed_jobs}}</div>
                      <div
                        style="font-family:Arial,sans-serif;font-size:12px;color:#15803D;font-weight:600;margin-top:4px;">
                        ✅ Jobs Completed</div>
                    </td>
                    <td width="4%"></td>
                    <td width="48%"
                      style="background-color:#FFF7ED;border:1px solid #FED7AA;border-radius:8px;padding:14px 16px;text-align:center;vertical-align:top;">
                      <div style="font-family:Arial,sans-serif;font-size:28px;font-weight:700;color:#EA580C;">
                        {{pending_jobs}}</div>
                      <div
                        style="font-family:Arial,sans-serif;font-size:12px;color:#C2410C;font-weight:600;margin-top:4px;">
                        ⏳ Jobs Pending</div>
                    </td>
                  </tr>
                </table>
              </div>
            </td>
          </tr>

          <!-- SECTION 8 — CUSTOMER & CREDIT SUMMARY -->
          <tr>
            <td style="background-color:#FFFFFF;padding:24px 28px 24px;">
              <div style="border-top:1px solid #F3F4F6;padding-top:24px;">
                <div
                  style="font-family:Arial,sans-serif;font-size:13px;font-weight:700;color:#6B7280;text-transform:uppercase;letter-spacing:0.8px;margin-bottom:14px;">
                  👥 Customer & Credit Summary — Grahak aur Udhaar</div>

                <table width="100%" cellpadding="0" cellspacing="0" border="0">
                  <tr>
                    <td width="48%"
                      style="text-align:center;background-color:#F8FAFF;border:1px solid #DBEAFE;border-radius:8px;padding:14px 16px;vertical-align:top;">
                      <div style="font-family:Arial,sans-serif;font-size:28px;font-weight:700;color:#1D4ED8;">
                        {{new_customers}}</div>
                      <div
                        style="font-family:Arial,sans-serif;font-size:12px;color:#1E40AF;font-weight:600;margin-top:4px;">
                        🆕 New Customers</div>
                    </td>
                    <td width="4%"></td>
                    <td width="48%"
                      style="text-align:center;background-color:#F8FAFF;border:1px solid #DBEAFE;border-radius:8px;padding:14px 16px;vertical-align:top;">
                      <div style="font-family:Arial,sans-serif;font-size:28px;font-weight:700;color:#1D4ED8;">
                        {{customers_served}}</div>
                      <div
                        style="font-family:Arial,sans-serif;font-size:12px;color:#1E40AF;font-weight:600;margin-top:4px;">
                        🤝 Customers Served</div>
                    </td>
                  </tr>
                </table>

                <table width="100%" cellpadding="0" cellspacing="0" border="0"
                  style="border-radius:8px;overflow:hidden;border:1px solid #E5E7EB;margin-top:12px;">
                  <tr>
                    <td
                      style="font-family:Arial,sans-serif;font-size:13px;color:#374151;padding:10px 16px;border-bottom:1px solid #F3F4F6;">
                      Credit Sales Today</td>
                    <td align="right"
                      style="font-family:Arial,sans-serif;font-size:13px;font-weight:600;color:#DC2626;padding:10px 16px;border-bottom:1px solid #F3F4F6;">
                      Rs. {{credit_sales_today}}</td>
                  </tr>
                  <tr style="background-color:#FAFAFA;">
                    <td
                      style="font-family:Arial,sans-serif;font-size:13px;color:#374151;padding:10px 16px;border-bottom:1px solid #F3F4F6;">
                      Old Credit Recovered</td>
                    <td align="right"
                      style="font-family:Arial,sans-serif;font-size:13px;font-weight:600;color:#059669;padding:10px 16px;border-bottom:1px solid #F3F4F6;">
                      Rs. {{credit_received}}</td>
                  </tr>
                  <tr style="background-color:#FFF7ED;">
                    <td
                      style="font-family:Arial,sans-serif;font-size:13px;font-weight:700;color:#C2410C;padding:10px 16px;">
                      Total Outstanding Balance</td>
                    <td align="right"
                      style="font-family:Arial,sans-serif;font-size:14px;font-weight:700;color:#C2410C;padding:10px 16px;">
                      Rs. {{total_customer_balance}}</td>
                  </tr>
                </table>
              </div>
            </td>
          </tr>

        </table>
      </td>
    </tr>
  </table>
</body>
</html>
`;

export default function DailySalesEmailTestPage() {
  const [data, setData] = useState<Record<string, string>>({
    report_date: '2026-07-20',
    owner_name: 'John Doe',
    company_name: 'SaleDesk POS',
    report_period: 'Today',
    days_remaining: '5',
    subscription_end_date: '2026-07-25',
    subscription_url: '#',
    total_sales: '250,000',
    total_invoices: '42',
    payments_received: '230,000',
    cash_collection: '150,000',
    bank_collection: '80,000',
    credit_amount: '20,000',
    gross_sales: '255,000',
    discount_total: '5,000',
    tax_total: '0',
    net_sales: '250,000',
    product_sales: '200,000',
    service_sales: '50,000',
    average_invoice_value: '5,952',
    highest_invoice_value: '120,000',
    cash_amount: '150,000',
    cash_pct: '60',
    bank_amount: '50,000',
    bank_pct: '20',
    card_amount: '30,000',
    card_pct: '12',
    wallet_amount: '0',
    wallet_pct: '0',
    raast_amount: '0',
    raast_pct: '0',
    cheque_amount: '0',
    cheque_pct: '0',
    credit_pct: '8',
    completed_jobs: '12',
    pending_jobs: '3',
    new_customers: '5',
    customers_served: '40',
    credit_sales_today: '20,000',
    credit_received: '15,000',
    total_customer_balance: '85,000'
  });

  const handleDataChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setData({
      ...data,
      [e.target.name]: e.target.value
    });
  };

  const renderedHtml = useMemo(() => {
    // Generate bank accounts HTML dynamically
    const bankAccountsHtml = `
      <tr style="background-color:#FAFAFA;">
        <td style="font-family:Arial,sans-serif;font-size:13px;color:#374151;padding:10px 16px;border-bottom:1px solid #F3F4F6;">
          🏦 Meezan Bank
        </td>
        <td align="right" style="font-family:Arial,sans-serif;font-size:13px;font-weight:600;color:#111827;padding:10px 16px;border-bottom:1px solid #F3F4F6;">
          Rs. ${data.bank_amount}
        </td>
        <td align="right" style="font-family:Arial,sans-serif;font-size:12px;color:#6B7280;padding:10px 16px;border-bottom:1px solid #F3F4F6;">
          ${data.bank_pct}%
        </td>
      </tr>
      <tr>
        <td style="font-family:Arial,sans-serif;font-size:13px;color:#374151;padding:10px 16px;border-bottom:1px solid #F3F4F6;">
          🏦 HBL Account
        </td>
        <td align="right" style="font-family:Arial,sans-serif;font-size:13px;font-weight:600;color:#111827;padding:10px 16px;border-bottom:1px solid #F3F4F6;">
          Rs. ${data.card_amount}
        </td>
        <td align="right" style="font-family:Arial,sans-serif;font-size:12px;color:#6B7280;padding:10px 16px;border-bottom:1px solid #F3F4F6;">
          ${data.card_pct}%
        </td>
      </tr>
    `;

    return rawTemplate.replace(/\{\{(.*?)\}\}/g, (_, key) => {
      const trimmedKey = key.trim();
      if (trimmedKey === 'bank_accounts_html') {
        return bankAccountsHtml;
      }
      return data[trimmedKey] || '';
    });
  }, [data]);

  return (
    <div className="flex h-screen w-full bg-gray-100 p-4 gap-4">
      {/* Dynamic Data Editor */}
      <div className="w-1/3 bg-white shadow rounded-lg p-4 flex flex-col h-full overflow-hidden">
        <h2 className="text-xl font-bold mb-4">Edit Template Data</h2>
        <div className="overflow-y-auto flex-1 pr-2">
          {Object.keys(data).map(key => (
            <div key={key} className="mb-3">
              <label className="block text-sm font-medium text-gray-700 mb-1">{key}</label>
              <input
                type="text"
                name={key}
                value={data[key]}
                onChange={handleDataChange}
                className="w-full px-3 py-2 border rounded-md shadow-sm focus:ring-blue-500 focus:border-blue-500 text-sm"
              />
            </div>
          ))}
        </div>
      </div>

      {/* Preview */}
      <div className="w-2/3 bg-white shadow rounded-lg h-full overflow-hidden flex flex-col">
        <div className="p-3 border-b bg-gray-50 flex justify-between items-center">
          <h2 className="text-lg font-semibold text-gray-800">Live Preview</h2>
          <span className="text-sm text-gray-500">Updates automatically as you type</span>
        </div>
        <iframe
          srcDoc={renderedHtml}
          className="flex-1 w-full border-none"
          title="Email Template Preview"
        />
      </div>
    </div>
  );
}
